import moment from "moment";
import React, { InputHTMLAttributes } from "react";
import {
  Control,
  Controller,
  FieldValues,
  Path,
  RegisterOptions,
} from "react-hook-form";
import { useTranslation } from "react-i18next";

interface DatePickerProps<FieldsType extends FieldValues> {
  name: Path<FieldsType>;
  control: Control<FieldsType>;
  rules?: RegisterOptions<FieldsType>;
  required?: boolean;
  label?: string;
  placeholder?: string;
  requiredMessage?: string;
  inputProps?: InputHTMLAttributes<HTMLInputElement>;
}

function DatePicker<FieldsType extends FieldValues>({
  label,
  name,
  control,
  required,
  requiredMessage,
  placeholder,
  rules,
}: DatePickerProps<FieldsType>) {
  const { t } = useTranslation();
  return (
    <Controller
      name={name}
      rules={{
        required: requiredMessage || (required && "Please select a date"),
        ...(rules || {}),
      }}
      defaultValue={null}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <div className="relative">
          <label className="text-base ml-1" htmlFor={field?.name}>
            <span>
              {t(label)}
              {(required || requiredMessage) && (
                <span className="text-red-600 ml-0.5 text-base">*</span>
              )}
            </span>
          </label>
          <input
            id={field.name}
            {...field}
            type={"date"}
            placeholder={placeholder || "DD/MM/YYYY"}
            min="2000-01-01"
            max={moment().format("YYYY-MM-DD")}
            className="placeholder:text-gray-500 border-gray-200 bg-transparent rounded-lg w-full px-2.5 py-3 border focus:border-brand-hover
            focus-within:border-brand-hover focus:bg-[#eaf1fa]  transition-all focus:ring-0 focus-visible:ring-0 focus-visible:border-brand-hover  outline-none"
          />
          <p className="text-red-600 font-normal text-sm m-0 p-0 ml-1  bottom-0 left-0 right-0">
            {error?.message}
          </p>
        </div>
      )}
    />
  );
}

export default DatePicker;
